import { PaginationButton } from "./PaginationButton";
type PaginationProps = {
  currentPage: number;
  totalData: number;
  rowsPerPage: number;
  totalPages: number;
  isTableDataLoading?: boolean;
  onPageChange: (page: number) => void;
  activePages: number[];
};

export const PaginationLayout = ({
  isTableDataLoading,
  totalData,
  currentPage,
  rowsPerPage,
  totalPages,
  onPageChange,
  activePages,
}: PaginationProps) => {
  return (
    <div>
      <PaginationButton
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1 || isTableDataLoading}
      >
        <img
          src={
            currentPage === 1
              ? require("../../assets/images/left-arrow-icon-disabled.png")
              : require("../../assets/images/left-arrow-icon.png")
          }
          alt="left-icon"
        />
      </PaginationButton>
      {activePages.map((pageNo: number, idx: number) => (
        <PaginationButton
          disabled={isTableDataLoading}
          key={idx}
          label={pageNo}
          isActive={currentPage === pageNo}
          onClick={() => onPageChange(pageNo)}
        />
      ))}
      <PaginationButton
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages || isTableDataLoading}
      >
        <img
          src={
            currentPage === totalPages
              ? require("../../assets/images/right-arrow-icon-disabled.png")
              : require("../../assets/images/right-arrow-icon.png")
          }
          alt="right-icon"
        />
      </PaginationButton>
    </div>
  );
};
